


































































































import Vue from "vue";
import ShortLinkService from "@/services/ShortLinkService";
import { CONSTANTS } from "@/config/constants";
import IntegrationService from "@/services/IntegrationService";
export default Vue.extend({
  props: ["open", "onFinish", "campaign"],
  data() {
    return {
      dialog: this.open,
      loading: false,
      valid: false,
      step: 1,
      csvArray: undefined,
      options: [],
      field: "",
      linkRules: [
        (v: string) =>
          (!!v && v.match(new RegExp("^https?://"))) || "Link inválido",
      ],
    };
  },
  watch: {
    open(val) {
      this.csvArray = JSON.parse(window.localStorage.getItem("@csv-array"));

      if (
        this.campaign.audienceCustomerList &&
        this.campaign.audienceCustomerList.length
      ) {
        this.options = ["nome"];
      } else if (this.csvArray) {
        this.options = this.csvArray[0];
      } else {
        this.options = [];
      }

      if (val) {
        this.step = 1;
        this.field = " ";
      }
      this.dialog = val;
    },
  },
  methods: {
    async addLink() {
      this.loading = true;
      try {
        const result = await ShortLinkService.createURLShortnerToCampaign(
          this.field,
          this.$store.state.campaign.campaign.objectId
        );
        this.$store.commit("addShortLink", result);
        this.onFinish(
          `${CONSTANTS.smsShortLinkPrefix}${result.objectId}`,
          "link"
        );
      } catch (error) {
        this.$store.commit("addSnackbar", {
          text: `Erro ao adicionar link: ${error.message}`,
        });
      }
      this.loading = false;
    },
    addToken() {
      this.onFinish(`{{${this.field}}}`, "token");
    },
    cleanToken(event: any) {
      this.field = this.field.replace(/[^\w\s]/gi, "");
    },
    cancel() {
      this.onFinish();
    },
    async addWhatsAppLink() {
      this.loading = true;
      try {
        const phone = IntegrationService.getPhoneNumber();
        const phoneNumber = `${phone.countryCode}${phone.areaCode}${phone.number}`;
        const result = await ShortLinkService.createURLShortnerToCampaign(
          `https://wa.me/${phoneNumber}`,
          this.$store.state.campaign.campaign.objectId
        );
        this.$store.commit("addShortLink", result);
        this.onFinish(
          `${CONSTANTS.smsShortLinkPrefix}${result.objectId}`,
          "link"
        );
      } catch (error) {
        this.$store.commit("addSnackbar", {
          text: `Erro ao adicionar link: ${error.message}`,
        });
      }
      this.loading = false;
    },
  },
});
